import axios from 'axios';
import { API } from '@/services/url';

export default {
  getSummary: function (success, error) {
    axios.get(API.dashboard.summary)
      .then(r => success(r.data))
      .catch(e => error(e.response ? e.response.data.message : e.message));
  }
};
